export interface Share {
    inherit: Inherit;
}

export enum Inherit {
    Custom = "CUSTOM",
    Inherit = "INHERIT",
}
